"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const escapeName = (name) => String(name)
    .replace(/\r/g, "%0D")
    .replace(/\n/g, "%0A")
    .replace(/"/g, "%22");
exports.default = escapeName;
